<kl-grid
  [columns]="[
    { header: 'code' | translate, binding: 'code', width: '*' },
    { header: 'description' | translate, binding: 'description', width: '*' }
  ]"
  [filterable]="false"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [mode]="'DIALOG'"
  [closeInside]="true"
  [service]="{
    service: 'vatgroups',
    name: 'vatgroups',
    form: 'VAT_GROUPS',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'APPLICATION_PARAMS'"
  [moduleName]="'VAT_GROUPS_LIST'"
  [gridName]="'grdVatGroupsList'"
>
</kl-grid>
